module.exports = __webpack_public_path__ + "static/media/eye_open.0b398a95.svg";